var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBarra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4037 3.47852H16.6637C15.8462 3.47852 15.1836 4.14117 15.1836 4.95859V15.3191C15.1836 16.1365 15.8462 16.7992 16.6637 16.7992H17.4037C18.2211 16.7992 18.8838 16.1365 18.8838 15.3191V4.95859C18.8838 4.14117 18.2211 3.47852 17.4037 3.47852Z",
    fill: "#6796CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0512 7.91895H11.3111C10.4937 7.91895 9.83105 8.5816 9.83105 9.39902V15.3193C9.83105 16.1367 10.4937 16.7994 11.3111 16.7994H12.0512C12.8686 16.7994 13.5312 16.1367 13.5312 15.3193V9.39902C13.5312 8.5816 12.8686 7.91895 12.0512 7.91895Z",
    fill: "#6796CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69862 13.0996H5.95859C5.14117 13.0996 4.47852 13.7623 4.47852 14.5797V15.3197C4.47852 16.1371 5.14117 16.7998 5.95859 16.7998H6.69862C7.51605 16.7998 8.1787 16.1371 8.1787 15.3197V14.5797C8.1787 13.7623 7.51605 13.0996 6.69862 13.0996Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarra);
export default __webpack_public_path__ + "static/media/IconBarra.2ac519927828ae8828af7755ceeb5843.svg";
export { ForwardRef as ReactComponent };